import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Loader2, ImageOff } from "lucide-react";

// Fetches a protected selfie as blob and renders it.
export function SelfieImage({ path, className, alt = "selfie" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let url;
    let active = true;
    if (!path) {
      setErr(true);
      return;
    }
    setErr(false);
    setSrc(null);
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (err)
    return (
      <div className={`${className} flex items-center justify-center bg-slate-100 text-slate-400`}>
        <ImageOff className="h-6 w-6" />
      </div>
    );
  if (!src)
    return (
      <div className={`${className} flex items-center justify-center bg-slate-100`}>
        <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
      </div>
    );
  return <img src={src} alt={alt} className={className} data-testid="selfie-image" />;
}
